// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ScrollToTop{bottom:200px;right:35px;width:35px;height:35px;position:fixed;background-color:#f44d57;border-radius:50%;display:flex;justify-content:center;align-items:center;z-index:10}@media(min-width:1100px){.ScrollToTop{bottom:50px;right:50px;width:50px;height:50px}}.ScrollToTop:hover{cursor:pointer;background-color:#e60e1b;transition:background-color .3s ease-in-out}.ScrollToTop svg{fill:#fff}", ""]);
// Exports
module.exports = exports;
